<template>
  <div class="train-list-container">
    <div class="cards-grid">
      <div v-for="(item, index) in cardList" :key="index" class="card-item">
        <div class="card-image">
          <img :src="item.majorImg" :alt="item.title" />
        </div>
        <div class="card-content">
          <div class="card-title">{{ item.majorTitle }}</div>
          <button class="card-button" @click="handleCardClick(item)">点击进入</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainList',
  props: ['categoryId'],
  data() {
    return {
      cardList: []
    }
  },
  mounted() {
    this.getCardList();
  },
  watch: {
    categoryId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getCardList();
      }
    }
  },
  methods: {
    getCardList() {
      var self = this;
      this.$http.post(API_ROOT.college + "/majors/queryFbtOperateMajors", { categoryId: this.categoryId }).then(res => {
        var result = res.data;
        if (result.success) {
          self.cardList = result.data;
        }
      }, (res) => {
        this.$alert("请求接口异常");
      }
      );
    },
    handleCardClick(item) {
      // 这里可以添加路由跳转或其他逻辑
      this.$router.push({
        name: 'fbtCourseList',
        query: { categoryId: item.categoryId,tjkId:item.tjkId }
      });
    }
  }
}
</script>

<style scoped>
.train-list-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 340px);
  gap: 20px;
  justify-content: start;
}

.card-item {
  width: 340px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.card-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.card-image {
  width: 340px;
  height: 220px;
  background-color: #a8c8ec;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  padding: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 auto;
  height: 106px;
}

.card-title {
  flex: 1;
  font-size: 16px;
  color: #333;
  line-height: 1.4;
  margin-right: 15px;
}

.card-button {
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5em 1em;
  font-size: 0.875em;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
  min-width: 0;
  flex-shrink: 0;
}

.card-button:hover {
  background-color: #40a9ff;
}

/* 响应式设计：自动换行，不限制每行数量 */
@media (max-width: 768px) {
  .cards-grid {
    gap: 15px;
  }

  .card-title {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/page/train/FBT/trainList.vue